<script lang="ts" setup>
import ButtonSettings from './ButtonSettings.vue'
import ButtonMic from './ButtonMic.vue'
import ButtonCamera from './ButtonCamera.vue'
import ButtonShare from './ButtonShare.vue'
import ButtonPip from './ButtonPip.vue'
import ButtonHowToJoin from './ButtonHowToJoin.vue'
import ButtonChat from './ButtonChat.vue'
import ButtonLearningPlatform from './ButtonLearningPlatform.vue'

defineOptions({
  name: 'ClassroomControlsBar',
})
</script>

<template>
  <div class="classroom-controls-bar">
    <div class="classroom-controls-bar__group classroom-controls-bar__group--left">
      <ButtonSettings />
    </div>

    <div class="classroom-controls-bar__group classroom-controls-bar__group--center">
      <ButtonMic />
      <ButtonCamera />
      <ButtonShare />
      <ButtonPip />
    </div>

    <div class="classroom-controls-bar__group classroom-controls-bar__group--right">
      <ButtonLearningPlatform />
      <ButtonHowToJoin />
      <ButtonChat />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./ClassroomControlsBar.scss" />
